/* tslint:disable */
/* eslint-disable */
/**
 * Bookings API
 * Bookings API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetConfig200ResponseCancellation } from './GetConfig200ResponseCancellation';
import {
    GetConfig200ResponseCancellationFromJSON,
    GetConfig200ResponseCancellationFromJSONTyped,
    GetConfig200ResponseCancellationToJSON,
    GetConfig200ResponseCancellationToJSONTyped,
} from './GetConfig200ResponseCancellation';
import type { GetConfig200ResponseWarranty } from './GetConfig200ResponseWarranty';
import {
    GetConfig200ResponseWarrantyFromJSON,
    GetConfig200ResponseWarrantyFromJSONTyped,
    GetConfig200ResponseWarrantyToJSON,
    GetConfig200ResponseWarrantyToJSONTyped,
} from './GetConfig200ResponseWarranty';
import type { GetConfig200ResponseBrandInfo } from './GetConfig200ResponseBrandInfo';
import {
    GetConfig200ResponseBrandInfoFromJSON,
    GetConfig200ResponseBrandInfoFromJSONTyped,
    GetConfig200ResponseBrandInfoToJSON,
    GetConfig200ResponseBrandInfoToJSONTyped,
} from './GetConfig200ResponseBrandInfo';

/**
 * 
 * @export
 * @interface GetConfig200Response
 */
export interface GetConfig200Response {
    /**
     * 
     * @type {GetConfig200ResponseWarranty}
     * @memberof GetConfig200Response
     */
    warranty: GetConfig200ResponseWarranty;
    /**
     * 
     * @type {GetConfig200ResponseCancellation}
     * @memberof GetConfig200Response
     */
    cancellation?: GetConfig200ResponseCancellation;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200Response
     */
    beforeUnit?: GetConfig200ResponseBeforeUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200Response
     */
    afterUnit?: GetConfig200ResponseAfterUnitEnum;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200Response
     */
    slotTime?: GetConfig200ResponseSlotTimeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200Response
     */
    locationId?: string;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200Response
     */
    afterTime?: number;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200Response
     */
    beforeTime?: number;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200Response
     */
    cancellationTime?: number;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200Response
     */
    cancellationUnit?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200Response
     */
    capacityType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200Response
     */
    capacityValue?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200Response
     */
    customPage: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200Response
     */
    dinersLimit?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200Response
     */
    duration?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200Response
     */
    extraText?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200Response
     */
    largeGroupCollision?: number;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200Response
     */
    largeGroupFrequency?: number;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200Response
     */
    largeGroupMin?: number | null;
    /**
     * 
     * @type {GetConfig200ResponseBrandInfo}
     * @memberof GetConfig200Response
     */
    brandInfo?: GetConfig200ResponseBrandInfo | null;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200Response
     */
    timezone: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200Response
     */
    locationAddress: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200Response
     */
    locationPhoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200Response
     */
    language: string;
    /**
     * 
     * @type {any}
     * @memberof GetConfig200Response
     */
    scripts: any | null;
}


/**
 * @export
 */
export const GetConfig200ResponseBeforeUnitEnum = {
    Minutes: 'minutes',
    Hours: 'hours',
    Days: 'days'
} as const;
export type GetConfig200ResponseBeforeUnitEnum = typeof GetConfig200ResponseBeforeUnitEnum[keyof typeof GetConfig200ResponseBeforeUnitEnum];

/**
 * @export
 */
export const GetConfig200ResponseAfterUnitEnum = {
    Minutes: 'minutes',
    Hours: 'hours',
    Days: 'days'
} as const;
export type GetConfig200ResponseAfterUnitEnum = typeof GetConfig200ResponseAfterUnitEnum[keyof typeof GetConfig200ResponseAfterUnitEnum];

/**
 * @export
 */
export const GetConfig200ResponseSlotTimeEnum = {
    NUMBER_15: 15,
    NUMBER_30: 30,
    NUMBER_45: 45,
    NUMBER_60: 60,
    NUMBER_90: 90,
    NUMBER_120: 120
} as const;
export type GetConfig200ResponseSlotTimeEnum = typeof GetConfig200ResponseSlotTimeEnum[keyof typeof GetConfig200ResponseSlotTimeEnum];


/**
 * Check if a given object implements the GetConfig200Response interface.
 */
export function instanceOfGetConfig200Response(value: object): value is GetConfig200Response {
    if (!('warranty' in value) || value['warranty'] === undefined) return false;
    if (!('customPage' in value) || value['customPage'] === undefined) return false;
    if (!('timezone' in value) || value['timezone'] === undefined) return false;
    if (!('locationAddress' in value) || value['locationAddress'] === undefined) return false;
    if (!('language' in value) || value['language'] === undefined) return false;
    if (!('scripts' in value) || value['scripts'] === undefined) return false;
    return true;
}

export function GetConfig200ResponseFromJSON(json: any): GetConfig200Response {
    return GetConfig200ResponseFromJSONTyped(json, false);
}

export function GetConfig200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfig200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'warranty': GetConfig200ResponseWarrantyFromJSON(json['warranty']),
        'cancellation': json['cancellation'] == null ? undefined : GetConfig200ResponseCancellationFromJSON(json['cancellation']),
        'beforeUnit': json['beforeUnit'] == null ? undefined : json['beforeUnit'],
        'afterUnit': json['afterUnit'] == null ? undefined : json['afterUnit'],
        'slotTime': json['slotTime'] == null ? undefined : json['slotTime'],
        'locationId': json['locationId'] == null ? undefined : json['locationId'],
        'afterTime': json['afterTime'] == null ? undefined : json['afterTime'],
        'beforeTime': json['beforeTime'] == null ? undefined : json['beforeTime'],
        'cancellationTime': json['cancellationTime'] == null ? undefined : json['cancellationTime'],
        'cancellationUnit': json['cancellationUnit'] == null ? undefined : json['cancellationUnit'],
        'capacityType': json['capacityType'] == null ? undefined : json['capacityType'],
        'capacityValue': json['capacityValue'] == null ? undefined : json['capacityValue'],
        'customPage': json['customPage'],
        'dinersLimit': json['dinersLimit'] == null ? undefined : json['dinersLimit'],
        'duration': json['duration'] == null ? undefined : json['duration'],
        'extraText': json['extraText'] == null ? undefined : json['extraText'],
        'largeGroupCollision': json['largeGroupCollision'] == null ? undefined : json['largeGroupCollision'],
        'largeGroupFrequency': json['largeGroupFrequency'] == null ? undefined : json['largeGroupFrequency'],
        'largeGroupMin': json['largeGroupMin'] == null ? undefined : json['largeGroupMin'],
        'brandInfo': json['brandInfo'] == null ? undefined : GetConfig200ResponseBrandInfoFromJSON(json['brandInfo']),
        'timezone': json['timezone'],
        'locationAddress': json['locationAddress'],
        'locationPhoneNumber': json['locationPhoneNumber'] == null ? undefined : json['locationPhoneNumber'],
        'language': json['language'],
        'scripts': json['scripts'],
    };
}

export function GetConfig200ResponseToJSON(json: any): GetConfig200Response {
    return GetConfig200ResponseToJSONTyped(json, false);
}

export function GetConfig200ResponseToJSONTyped(value?: GetConfig200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'warranty': GetConfig200ResponseWarrantyToJSON(value['warranty']),
        'cancellation': GetConfig200ResponseCancellationToJSON(value['cancellation']),
        'beforeUnit': value['beforeUnit'],
        'afterUnit': value['afterUnit'],
        'slotTime': value['slotTime'],
        'locationId': value['locationId'],
        'afterTime': value['afterTime'],
        'beforeTime': value['beforeTime'],
        'cancellationTime': value['cancellationTime'],
        'cancellationUnit': value['cancellationUnit'],
        'capacityType': value['capacityType'],
        'capacityValue': value['capacityValue'],
        'customPage': value['customPage'],
        'dinersLimit': value['dinersLimit'],
        'duration': value['duration'],
        'extraText': value['extraText'],
        'largeGroupCollision': value['largeGroupCollision'],
        'largeGroupFrequency': value['largeGroupFrequency'],
        'largeGroupMin': value['largeGroupMin'],
        'brandInfo': GetConfig200ResponseBrandInfoToJSON(value['brandInfo']),
        'timezone': value['timezone'],
        'locationAddress': value['locationAddress'],
        'locationPhoneNumber': value['locationPhoneNumber'],
        'language': value['language'],
        'scripts': value['scripts'],
    };
}

